const dscJcamp = `
##TITLE=DSC1.1_bagit
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1


$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=DSC1.1_bagit
##JCAMP-DX=5.00
##DATA TYPE=DIFFERENTIAL SCANNING CALORIMETRY
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=DEGREES CELSIUS
##YUNITS=W/g
##XFACTOR=1.0
##YFACTOR=1.0
##FIRSTX=-63.0
##LASTX=77.0
##MAXX=77.0
##MAXY=0.25175
##MINX=-63.0
##MINY=0.11677
##MELTINGPOINT=1.5
##TG=6
##NPOINTS=141
##XYDATA= (XY..XY)
-63.0, 0.11677
-62.0, 0.11735
-61.0, 0.11846
-60.0, 0.11883
-59.0, 0.12039
-58.0, 0.12119
-57.0, 0.12283
-56.0, 0.12307
-55.0, 0.12475
-54.0, 0.12572
-53.0, 0.12679
-52.0, 0.12734
-51.0, 0.12816
-50.0, 0.12912
-49.0, 0.13037
-48.0, 0.13143
-47.0, 0.13223
-46.0, 0.133
-45.0, 0.13489
-44.0, 0.13631
-43.0, 0.13762
-42.0, 0.13922
-41.0, 0.14115
-40.0, 0.14282
-39.0, 0.14512
-38.0, 0.14791
-37.0, 0.15185
-36.0, 0.15621
-35.0, 0.16347
-34.0, 0.17107
-33.0, 0.181
-32.0, 0.1906
-31.0, 0.19701
-30.0, 0.19835
-29.0, 0.19769
-28.0, 0.19625
-27.0, 0.19572
-26.0, 0.19538
-25.0, 0.19507
-24.0, 0.19475
-23.0, 0.1959
-22.0, 0.19594
-21.0, 0.19629
-20.0, 0.19673
-19.0, 0.19782
-18.0, 0.19831
-17.0, 0.19894
-16.0, 0.19921
-15.0, 0.20047
-14.0, 0.20127
-13.0, 0.20227
-12.0, 0.20231
-11.0, 0.20364
-10.0, 0.20473
-9.0, 0.20614
-8.0, 0.20717
-7.0, 0.20811
-6.0, 0.20812
-5.0, 0.20888
-4.0, 0.2094
-3.0, 0.20991
-2.0, 0.2107
-1.0, 0.21024
0.0, 0.21301
1.0, 0.21343
2.0, 0.21476
3.0, 0.21539
4.0, 0.21575
5.0, 0.21741
6.0, 0.21804
7.0, 0.21857
8.0, 0.21968
9.0, 0.22042
10.0, 0.22132
11.0, 0.2219
12.0, 0.22323
13.0, 0.22292
14.0, 0.2238
15.0, 0.22403
16.0, 0.22516
17.0, 0.22501
18.0, 0.22537
19.0, 0.22724
20.0, 0.22789
21.0, 0.22903
22.0, 0.22874
23.0, 0.22968
24.0, 0.23052
25.0, 0.23125
26.0, 0.23222
27.0, 0.23264
28.0, 0.23352
29.0, 0.2329
30.0, 0.23468
31.0, 0.23594
32.0, 0.23694
33.0, 0.23795
34.0, 0.23884
35.0, 0.23874
36.0, 0.2388
37.0, 0.23787
38.0, 0.23632
39.0, 0.23466
40.0, 0.2341
41.0, 0.23385
42.0, 0.23285
43.0, 0.23268
44.0, 0.23306
45.0, 0.23314
46.0, 0.23343
47.0, 0.23341
48.0, 0.23417
49.0, 0.23427
50.0, 0.2345
51.0, 0.23501
52.0, 0.23577
53.0, 0.23657
54.0, 0.23737
55.0, 0.23798
56.0, 0.23837
57.0, 0.23914
58.0, 0.23969
59.0, 0.24067
60.0, 0.24087
61.0, 0.24185
62.0, 0.24243
63.0, 0.24258
64.0, 0.24378
65.0, 0.24441
66.0, 0.24479
67.0, 0.24473
68.0, 0.24596
69.0, 0.24651
70.0, 0.24716
71.0, 0.2482
72.0, 0.24848
73.0, 0.24912
74.0, 0.25051
75.0, 0.25049
76.0, 0.2509
77.0, 0.25175
$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##$OBSERVEDINTEGRALS= (X Y Z)

##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
$$ === CHEMSPECTRA SIMULATION ===
##$CSSIMULATIONPEAKS=
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=DSC1.1_bagit
##JCAMP-DX=5.00
##DATA TYPE=DIFFERENTIAL SCANNING CALORIMETRYPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=1.05
##MAXX=77.0
##MAXY=0.25175
##MINX=-63.0
##MINY=0.11677
##$CSSOLVENTNAME=- - -
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=0
##PEAKTABLE= (XY..XY)
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=DSC1.1_bagit
##JCAMP-DX=5.00
##DATA TYPE=DIFFERENTIAL SCANNING CALORIMETRYPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=1.05
##MAXX=77.0
##MAXY=0.25175
##MINX=-63.0
##MINY=0.11677
##NPOINTS=0
##PEAKTABLE= (XY..XY)
##END=


$$ === CHEMSPECTRA ORIGINAL METADATA ===
###TITLE= DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit
###JCAMPDX= 5.0, 5.00, 5.00, 5.00
###BLOCKS= 1
###$CSCATEGORY= SPECTRUM, EDIT_PEAK, AUTO_PEAK
###XUNITS= DEGREES CELSIUS
###YUNITS= W/g
###LASTX= 77.0
###MAXX= 77.0, 77.0, 77.0
###MAXY= 0.25175, 0.25175, 0.25175
###MINX= -63.0, -63.0, -63.0
###MINY= 0.11677, 0.11677, 0.11677
###MELTINGPOINT= 1.5
###TG= 6
###NPOINTS= 141, 0, 0
###$OBSERVEDINTEGRALS= (X Y Z)
###$CSTHRESHOLD= 1.05, 1.05
###$CSSOLVENTNAME= - - -
###$CSSOLVENTVALUE= 0
###$CSSOLVENTX= 0
###TITLE= DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, DSC1.1_bagit, Spectrum
###JCAMPDX= 5.0, 5.00, 5.00, 5.00, 5.0, 5.00, 5.00, 5.00, 5.0, 5.00, 5.00, 5.00, 5.0, 5.00, 5.00, 5.00, 5.0, 5.00, 5.00, 5.00, 5.0, 5.00, 5.00, 5.00, 5.0, 5.00, 5.00, 5.00, 5.0, 5.00, 5.00, 5.00, 5.0, 5.00, 5.00, 5.00, 5.00
###BLOCKS= 1, 1, 1, 1, 1, 1, 1, 1, 1
###$CSCATEGORY= SPECTRUM, EDIT_PEAK, AUTO_PEAK, SPECTRUM, EDIT_PEAK, AUTO_PEAK, SPECTRUM, EDIT_PEAK, AUTO_PEAK, SPECTRUM, EDIT_PEAK, AUTO_PEAK, SPECTRUM, EDIT_PEAK, AUTO_PEAK, SPECTRUM, EDIT_PEAK, AUTO_PEAK, SPECTRUM, EDIT_PEAK, AUTO_PEAK, SPECTRUM, EDIT_PEAK, AUTO_PEAK, SPECTRUM, EDIT_PEAK, AUTO_PEAK
###XUNITS= DEGREES CELSIUS, DEGREES CELSIUS, DEGREES CELSIUS, DEGREES CELSIUS, DEGREES CELSIUS, DEGREES CELSIUS, DEGREES CELSIUS, DEGREES CELSIUS, DEGREES CELSIUS, DEGREES CELSIUS, DEGREES CELSIUS
###YUNITS= W/g, W/g, W/g, W/g, W/g, W/g, W/g, W/g, W/g, W/g, W/g
###LASTX= 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.00000
###MAXX= 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0, 77.0
###MAXY= 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175, 0.25175
###MINX= -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0, -63.0
###MINY= 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677, 0.11677
###NPOINTS= 141, 0, 0, 141, 0, 0, 141, 0, 0, 141, 0, 0, 141, 0, 0, 141, 0, 0, 141, 0, 0, 141, 0, 0, 141, 0, 0, 141
###$OBSERVEDINTEGRALS= (X Y Z), (X Y Z), (X Y Z), (X Y Z), (X Y Z), (X Y Z), (X Y Z), (X Y Z), (X Y Z)
###$CSTHRESHOLD= 1.05, 1.05, 1.05, 1.05, 1.05, 1.05, 1.05, 1.05, 1.05, 1.05, 1.05, 1.05, 1.05, 1.05, 1.05, 1.05, 1.05, 1.05
###$CSSOLVENTNAME= - - -, - - -, - - -, - - -, - - -, - - -, - - -
###$CSSOLVENTVALUE= 0, 0, 0, 0, 0, 0, 0, 0, 0
###$CSSOLVENTX= 0, 0, 0, 0, 0, 0, 0, 0, 0
###SAMPLE= SB
###AMOUNT= 6,4
###DATE= 31.03.2022
###TIME= 12:47:59 (UTC+2)
###REFERENCE= -----
###REFERENCEMASS= 0.0
###TEMPCAL= 14-03-2022
###SENSFILE= 14-03-2022
###SEGMENTS= 4/4
###BRAND= NETZSCH
###INSTRUMENT= DSC 214
###CRUCIBLE= Concavus Al, pierced lid
###ATMOSPHERE= NITROGEN,250,0 ml/min
###RANGE= 5.0
###TEMPERATURE= -80C/10,0(K/min)/200C
###OPERATOR= SB
###XYPOINTS= (XY..XY)
-63.00000, 0.11677
-62.00000, 0.11735
-61.00000, 0.11846
-60.00000, 0.11883
-59.00000, 0.12039
-58.00000, 0.12119
-57.00000, 0.12283
-56.00000, 0.12307
-55.00000, 0.12475
-54.00000, 0.12572
-53.00000, 0.12679
-52.00000, 0.12734
-51.00000, 0.12816
-50.00000, 0.12912
-49.00000, 0.13037
-48.00000, 0.13143
-47.00000, 0.13223
-46.00000, 0.13300
-45.00000, 0.13489
-44.00000, 0.13631
-43.00000, 0.13762
-42.00000, 0.13922
-41.00000, 0.14115
-40.00000, 0.14282
-39.00000, 0.14512
-38.00000, 0.14791
-37.00000, 0.15185
-36.00000, 0.15621
-35.00000, 0.16347
-34.00000, 0.17107
-33.00000, 0.18100
-32.00000, 0.19060
-31.00000, 0.19701
-30.00000, 0.19835
-29.00000, 0.19769
-28.00000, 0.19625
-27.00000, 0.19572
-26.00000, 0.19538
-25.00000, 0.19507
-24.00000, 0.19475
-23.00000, 0.19590
-22.00000, 0.19594
-21.00000, 0.19629
-20.00000, 0.19673
-19.00000, 0.19782
-18.00000, 0.19831
-17.00000, 0.19894
-16.00000, 0.19921
-15.00000, 0.20047
-14.00000, 0.20127
-13.00000, 0.20227
-12.00000, 0.20231
-11.00000, 0.20364
-10.00000, 0.20473
 -9.00000, 0.20614
 -8.00000, 0.20717
 -7.00000, 0.20811
 -6.00000, 0.20812
 -5.00000, 0.20888
 -4.00000, 0.20940
 -3.00000, 0.20991
 -2.00000, 0.21070
 -1.00000, 0.21024
  0.00000, 0.21301
  1.00000, 0.21343
  2.00000, 0.21476
  3.00000, 0.21539
  4.00000, 0.21575
  5.00000, 0.21741
  6.00000, 0.21804
  7.00000, 0.21857
  8.00000, 0.21968
  9.00000, 0.22042
 10.00000, 0.22132
 11.00000, 0.22190
 12.00000, 0.22323
 13.00000, 0.22292
 14.00000, 0.22380
 15.00000, 0.22403
 16.00000, 0.22516
 17.00000, 0.22501
 18.00000, 0.22537
 19.00000, 0.22724
 20.00000, 0.22789
 21.00000, 0.22903
 22.00000, 0.22874
 23.00000, 0.22968
 24.00000, 0.23052
 25.00000, 0.23125
 26.00000, 0.23222
 27.00000, 0.23264
 28.00000, 0.23352
 29.00000, 0.23290
 30.00000, 0.23468
 31.00000, 0.23594
 32.00000, 0.23694
 33.00000, 0.23795
 34.00000, 0.23884
 35.00000, 0.23874
 36.00000, 0.23880
 37.00000, 0.23787
 38.00000, 0.23632
 39.00000, 0.23466
 40.00000, 0.23410
 41.00000, 0.23385
 42.00000, 0.23285
 43.00000, 0.23268
 44.00000, 0.23306
 45.00000, 0.23314
 46.00000, 0.23343
 47.00000, 0.23341
 48.00000, 0.23417
 49.00000, 0.23427
 50.00000, 0.23450
 51.00000, 0.23501
 52.00000, 0.23577
 53.00000, 0.23657
 54.00000, 0.23737
 55.00000, 0.23798
 56.00000, 0.23837
 57.00000, 0.23914
 58.00000, 0.23969
 59.00000, 0.24067
 60.00000, 0.24087
 61.00000, 0.24185
 62.00000, 0.24243
 63.00000, 0.24258
 64.00000, 0.24378
 65.00000, 0.24441
 66.00000, 0.24479
 67.00000, 0.24473
 68.00000, 0.24596
 69.00000, 0.24651
 70.00000, 0.24716
 71.00000, 0.24820
 72.00000, 0.24848
 73.00000, 0.24912
 74.00000, 0.25051
 75.00000, 0.25049
 76.00000, 0.25090
 77.00000, 0.25175


##END=




`;

export default dscJcamp;
